module.exports = __webpack_public_path__ + "static/level-7-card.0c2c43c0.png";